import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import { BaseBackResponse } from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.marketplace}tickets`;

export interface CloseTicketCommandArgs {
  ticketId: string;
}

export const closeTicketRequest = (
  payload: CloseTicketCommandArgs,
): ApiRequestDescriptor => ({
  url: `${ENDPOINT}/${payload.ticketId}/close`,
  config: { method: SUPPORTED_METHODS.PUT },
});

export const closeTicketCommand = async (
  payload: CloseTicketCommandArgs,
): Promise<BaseBackResponse> => {
  try {
    return await executeQuery<BaseBackResponse>(closeTicketRequest(payload));
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
